import React, { useEffect, useState } from "react";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
  Box,
  Stack,
  Divider,
} from "@mui/material";
import { Question } from "./type";
import { RenderHTMLContent, RenderHTMLContent2 } from "./extractQuestions";
import { green, pink, yellow } from "@mui/material/colors";
import ImageBox from "./ImageBox";
import PillButton from "./PillButton";

// Props for the MTCQuestion component
interface MTCQuestionProps {
  question: Question;
  editable?: boolean;
  onAnswerChange?: (answer: string) => void;
  answer?: string;
  formatSize?: number;
  checkCorrect?: boolean;
}

interface CustomFormControlLabelProps {
  value: string;
  label: React.ReactNode;
  formatSize?: number;
  checkCorrect?: boolean;
  correctAnswer?: string;
  answer?: string;
}

// Props for the QuestionPart component
interface QuestionPartProps {
  partLabel: string; // 'a', 'b', 'c', 'd'
  questionContent: string;
  formatSize?: number;
  questionImageUrl?: string;
}

const QuestionPart: React.FC<QuestionPartProps> = ({
  partLabel,
  questionContent,
  questionImageUrl,
  formatSize = 0.8,
}) => {
  return (
    <Box
      // mb={0.5}
      // mr={1}
      display="flex"
      alignItems="center"
      justifyContent={"center"}
    >
      {RenderHTMLContent2(questionContent, partLabel + ".")}
      {questionImageUrl && (
        // <Box
        //   component="img"
        //   src={questionImageUrl}
        //   alt={`Question ${questionImageUrl}`}
        //   onLoad={handleImageLoad}
        //   sx={{
        //     float: 'right',
        //     marginLeft: 2,
        //     marginBottom: 2,
        //     width: imageSize.width * formatSize + 'px',
        //     height: 'auto',
        //   }}
        // />
        <ImageBox
          src={questionImageUrl}
          alt={`Question ${questionImageUrl}`}
          formatSize={formatSize}
        />
      )}
    </Box>
  );
};

const CustomFormControlLabel: React.FC<CustomFormControlLabelProps> = ({
  value,
  label,
  formatSize = 0.8,
}) => {
  return (
    <FormControlLabel
      value={value}
      control={
        <Radio
          sx={{
            "& .MuiSvgIcon-root": {
              fontSize: formatSize + 0.5 + "rem",
            },
            color: yellow[800],
            "&.Mui-checked": {
              color: yellow[700],
            },
          }}
        />
      }
      label={<Typography variant="examText">{label}</Typography>}
      sx={{
        py: formatSize - 0.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
      }}
    />
  );
};

interface ChoiceRadioProps {
  value: string;
  selected: string;
  onChange: (v: string) => void;
  disabled?: boolean;
  formatSize?: number;
}
// interface ChoiceButtonProps {
//   value: 'A' | 'B' | 'C' | 'D';
//   selected: boolean;
//   disabled?: boolean;
//   onClick: () => void;
//   formatSize?: number;
// }

// const ChoiceButton: React.FC<ChoiceButtonProps> = ({
//   value,
//   selected,
//   disabled,
//   onClick,
//   formatSize = 1,
// }) => {
//   return (
//     <Box
//       onClick={() => {
//         if (!disabled) onClick();
//       }}
//       sx={{
//         width: 24,
//         height: 24,
//         borderRadius: '50%',
//         border: '1px solid',
//         borderColor: selected ? 'primary.main' : 'divider',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         cursor: disabled ? 'default' : 'pointer',
//         bgcolor: selected ? 'primary.main' : 'transparent',
//         color: selected ? 'primary.contrastText' : 'text.primary',
//         transition: 'all 0.15s ease',
//         userSelect: 'none',

//         // '&:hover': {
//         //   bgcolor: disabled
//         //     ? 'transparent'
//         //     : selected
//         //     ? 'primary.dark'
//         //     : 'action.hover',
//         // },
//       }}
//     >
//       <Typography
//       variant='subtitle2'
//         sx={{
//           fontWeight: 500,
//           fontSize: formatSize - 0.3  + 'rem',
//         }}
//       >
//         {value}
//       </Typography>
//     </Box>
//   );
// };
const MTCQuestion: React.FC<MTCQuestionProps> = ({
  question,
  editable,
  onAnswerChange,
  answer,
  formatSize = 1,
  checkCorrect = false,
}) => {
  const [selected, setSelected] = useState("");

  useEffect(() => {
    if (answer !== undefined) {
      setSelected(answer || "");
    } else {
      setSelected(question.correctAnswer);
    }
  }, [answer, question.correctAnswer]);

  const handleSelect = (v: string) => {
    if (!editable || checkCorrect) return;
    setSelected(v);
    onAnswerChange?.(v);
  };

  if (question.type !== "mcq") return null;

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        alignItems: "center",
        my: 0.5,
      }}
    >
      {(["A", "B", "C", "D"] as const).map((opt) => (
        <PillButton
          key={opt}
          label={opt}
          selected={selected === opt}
          disabled={!editable || checkCorrect}
          onClick={() => handleSelect(opt)}
          isCorrectAnswer={question.correctAnswer === opt}
          isCheckAnswer={checkCorrect}
        />
      ))}
    </Box>
  );
};

export default MTCQuestion;
